import React from 'react';
import { Link } from 'react-router-dom';
import CounterUp from './CounterUp';


const CounterUpTwo = () => {
    return (
        <div className="section section-padding expert-counterup-area ">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-5">
                        <div className="section-heading heading-left">
                            <span className="subtitle">Experts dans le domaine</span>
                            <h2>Qu'est-ce qui nous rend spéciaux?</h2>
                            <p className="mb--50">Les balises GPS auto sont de plus en plus convoités par les particuliers en quête de tranquillité, mais aussi les professionnels qui cherchent à traquer leurs salariés notamment les commerciaux ou les artisans. Ces systèmes de géolocalisation sont très simples d'utilisation.</p>
                            <Link to={process.env.PUBLIC_URL + "/contact"} className="axil-btn btn-large btn-fill-primary">Contact</Link>
                        </div>
                    </div>
                    <div className="col-lg-6 offset-xl-1">
                        <div className="row">
                            <CounterUp colSize="col-sm-6" layoutStyle="counterup-style-2" evenTopMargin="" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


export default CounterUpTwo;